export const allergenData: { [key: string]: string[] } = {
  // ENTRANTES
  "Consomé": ["apio", "gluten"],
  "Consomé con Yema": ["apio", "gluten", "huevo"],
  "Sopa de Cocido": ["apio", "gluten"],
  "Crep de Farinato": ["gluten", "leche", "huevo"],
  "Crepe de farinato": ["gluten", "leche", "huevo"],
  "Plato del Día": [],
  "Gazpacho (Temporada)": [],
  "Entremeses": ["gluten", "leche", "huevo", "pescado"],
  "Guisantes con Jamón": ["leche"],
  "Alcachofas con Jamón": ["leche"],
  "Revuelto de Gambas": ["huevo", "crustaceos", "leche"],
  "Revuelto de Champiñones y Gambas": ["huevo", "crustaceos", "leche"],
  "Revuelto de Trigueros y Gambas": ["huevo", "crustaceos", "leche"],
  "Morcilla de Arroz con Pimientos": ["gluten"],
  "Morcilla de Arroz con pimientos": ["gluten"],

  // ENSALADAS
  "Ensalada Normal": ["sulfitos", "leche"],
  "Ensalada Mixta": ["sulfitos", "leche"],
  "Ensalada de Naranja": [],
  "Ensalada de Frutos Secos con Rulo de Cabra": ["nuts", "leche"],
  "Ensalada de Frutos de Secos con Rulo de Cabra": ["nuts", "leche"],
  "Ensalada de Tomate con Queso Mozzarella": ["leche"],
  "Ensalada de Tomate con Queso Mozarella": ["leche"],
  "Espárragos Blancos": [],

  // IBÉRICOS
  "Ración de Queso Curado": ["leche"],
  "Ración de Chorizo Ibérico": ["sulfitos"],
  "Ración de Chorico Iberico": ["sulfitos"],
  "Ración de Salchichón Ibérico": ["sulfitos"],
  "Ración de Lomo Ibérico": ["sulfitos"],
  "Ración de Lamo Iberico": ["sulfitos"],
  "Tabla Surtido de Ibéricos": ["leche", "sulfitos"],
  "Tabla Surtida de Ibericos": ["leche", "sulfitos"],
  "Ración de Pan": ["gluten"],

  // CARNES
  "Ternera a la Plancha con Patatas": ["leche"],
  "Escalope de Ternera con Patatas": ["gluten", "leche"],
  "Lomo de Cerdo con Patatas": ["leche"],
  "Solomillo de Cerdo a la plancha": ["leche"],
  "Solomillo de Cerdo (a la Plancha o Roquefort)": ["leche"],
  "Solomillo de Cerdo con Salsa Roquefort": ["leche"],
  "Pechuga de Pollo a la Plancha con Patatas": ["leche"],
  "Pechuga de Pollo a la plancha con patatas": ["leche"],
  "Pechuga de Pollo a la Plancha": ["leche"],
  "Escalope de Pollo con Patatas": ["gluten"],
  "Escalope de Pollo con patatas": ["gluten"],
  "Escalope de Pollo": ["gluten"],
  "Chuletillas de Cordero con Patatas": ["leche"],
  "Chuletillas de Cordero con patatas": ["leche"],
  "Entrecot con Patatas": ["leche"],
  "Entrecot con patatas": ["leche"],
  "Chuletón con Patatas y Pimientos": ["leche"],
  "Chuletón con patatas y pimientos": ["leche"],
  "Callos con Chorizo al estilo Cata": ["gluten", "sulfitos"],
  "Callos al estilo Cata": ["gluten", "sulfitos"],
  "Morros de Ternera Rebozados": ["gluten", "huevo"],

  // PESCADOS
  "Calamares a la Romana": ["gluten", "moluscos"],
  "Sepia a la Plancha": ["moluscos"],
  "Pescado del Día": ["pescado"],
  "Gambas Ajillo": ["crustaceos", "gluten", "sulfitos"],
  "Gambas al ajillo": ["crustaceos", "gluten", "sulfitos"],

  // PLATOS COMBINADOS
  "Nº1. Huevos con Farinato y Patatas": ["huevo", "gluten", "leche"],
  "Nº2. Huevos con Bacon y Patatas": ["huevo", "gluten"],
  "Nº3. Huevos con Chorizo y Patatas": ["huevo", "gluten"],
  "Nº4. Huevos con Jamón y Patatas": ["huevo", "gluten"],
  "Nº5. Lomo, Bacon, Huevo y Patatas": ["huevo", "gluten"],
  "Nº6. Lomo, Tortilla, Espárragos y Patatas": ["huevo", "gluten"],
  "Nº7. Pechuga, Huevo, Bacon y Patatas": ["huevo", "gluten"],
  "Nº8. Ternera, Huevo, Bacon y Patatas": ["huevo", "gluten"],
  "Nº9. Escalope de Ternera, Huevo y Patatas": ["huevo", "gluten"],
  "Nº10. Tortilla Francesa, Calamares y Patatas": ["huevo", "gluten", "moluscos"],
  "Nº11. Tortilla Francesa con Patatas": ["huevo", "gluten"],
  "Nº12. Tortilla Francesa con Jamón y Patatas": ["huevo", "gluten"],
  "Nº13. Tortilla Francesa con Atún y Patatas": ["huevo", "gluten"],
  "Nº14. Huevos con Patatas": ["huevo", "gluten"],
  "Nº15. Sándwich Mixto": ["gluten", "leche", "huevo"],
  "Nº16. Sándwich de la Casa": ["gluten", "leche", "huevo"],

  // MENÚ DEL DÍA - PRIMEROS
  "LUNES: Cocido Completo (solo por encargo)": ["gluten", "apio"],
  "Judías con Jamón": ["leche"],
  "Arroz a la Cubana": ["huevo", "gluten"],
  "Macarrones con Atún y Tomate": ["gluten", "pescado"],

  // MENÚ DEL DÍA - SEGUNDOS
  "Lomo de Cerdo": ["leche"],
  "Huevos con Patatas": ["huevo"],
  "Huevos con Farinato": ["huevo", "gluten"],
  "Huevos con Chorizo": ["huevo"],

  // MENÚ INFANTIL - PRIMEROS
  "Macarrones con Tomate": ["gluten"],

  // MENÚ INFANTIL - SEGUNDOS
  "Huevo con Patatas": ["huevo"],
  "Lomo de cerdo con Patatas": ["leche"],

  // POSTRES
  "Natillas": ["leche", "huevo"],
  "Cuajada": ["leche"],
  "Crema de Queso con mermelada de Arándanos": ["leche", "gluten"],
  "Helado": ["leche", "huevo"],
  "Fruta del tiempo": [],

  // MONTADITOS
  "Lomo a la Plancha": [],
  "Pechuga de Pollo": [],
  "Bacon a la Plancha": [],
  "Barbada a la Plancha": [],
};

export const allergenIcons: { [key: string]: string } = {
  "altramuces": "/alergenos/altramuces.svg",
  "apio": "/alergenos/apio.svg",
  "cacahuetes": "/alergenos/cacahuetes.svg",
  "crustaceos": "/alergenos/crustaceos.svg",
  "gluten": "/alergenos/gluten.svg",
  "huevo": "/alergenos/huevo.svg",
  "leche": "/alergenos/leche.svg",
  "marisco": "/alergenos/marisco.svg",
  "moluscos": "/alergenos/moluscos.svg",
  "mostaza": "/alergenos/mostaza.svg",
  "nuts": "/alergenos/nuts.svg",
  "pescado": "/alergenos/pescado.svg",
  "sesamo": "/alergenos/sesamo.svg",
  "soja": "/alergenos/soja.svg",
  "sulfitos": "/alergenos/sulfitos.svg",
};
